import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { MinutasPronosticoState } from './types'

export const getters: GetterTree<MinutasPronosticoState, RootState> = {
  minutasPronostico (state: MinutasPronosticoState) {
    return state.minutasPronostico
  },
  linkDescarga (state: MinutasPronosticoState) {
    return state.link_descarga
  }
}
